import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FONTS } from '../utils/styleConstants';

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

const LoadingSkeleton = styled.div`
  background: linear-gradient(90deg, #ff7057 25%, #e55a42 50%, #ff7057 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
  height: 1em;
  width: 120px;
  opacity: 0.7;
`;

const CreditsText = styled.div`
  font-size: 0.65rem;
  color: #ff7057;
  text-align: center;
  font-family: ${FONTS.PRIMARY};
  font-weight: 500;
  white-space: nowrap;
`;

const CreditsDisplay = ({ isLoading, credits, format = 'sidebar' }) => {
  if (isLoading && !credits) {
    return format === 'sidebar' ? <LoadingSkeleton /> : { number: '...', label: 'CARGANDO...' };
  }
  
  if (!credits) {
    const display = format === 'sidebar' 
      ? '0/0 OFERTAS DISPONIBLES'
      : { number: '0/0', label: 'OFERTAS DISPONIBLES' };
    return format === 'sidebar' ? <CreditsText>{display}</CreditsText> : display;
  }
  
  if (format === 'sidebar') {
    const text = `${credits.credits.available}/${credits.credits.total_purchased} OFERTAS DISPONIBLES`;
    return <CreditsText>{text}</CreditsText>;
  }
  
  return {
    number: `${credits.credits.available}/${credits.credits.total_purchased}`,
    label: 'OFERTAS DISPONIBLES'
  };
};

export default CreditsDisplay; 